<template>
  <div class="py-6">
    <div class="flex flex-row w-full mb-2">
      <div class="w-1/2">
        <h2 class="text-gray-dark font-normal text-base mb-1">{{ heading }}</h2>
        <h3 v-if="subheading" class="text-gray-dark font-normal text-sm mb-1">{{ subheading }}</h3>
      </div>
      <div v-if="refreshed_at" class="w-1/2 text-right">
        <div class="font-normal mb-1"><a  class="text-blue-dark text-base cursor-pointer hover:underline" @click.prevent="$emit('refresh')">Import latest Land Registry data</a></div>
        <div v-if="subheading" class="text-gray-dark font-normal text-sm mb-1">Data refreshed at {{ refreshed_at }}</div>
      </div>
    </div>
    <figures-and-charts :data="data" v-if="!incomeOnly" />
    <income-chart :figures="data.figures" v-if="!figureOnly" />
  </div>
</template>
<script>
import FiguresAndCharts from './FiguresAndCharts.vue'
import IncomeChart from './IncomeChart.vue'
export default {
  components: { FiguresAndCharts, IncomeChart },
  data () {
    return {
    }
  },
  props: {
    data: {
      type: Object,
      default: null
    },
    refreshed_at: {
      type: String,
      default: null
    },
    heading: {
      type: String,
      default: 'Market Figures'
    },
    subheading: {
      type: String,
      default: null
    },
    figureOnly: {
      type: Boolean,
      default: false
    },
    incomeOnly: {
      type: Boolean,
      default: false
    }
  }
}
</script>
